import * as React from 'react';
import { Highlight } from './Highlight';
import type { CultivTestimonial } from '../types';

/* Shared building blocks of the marketing pages: section heading, stats row,
   testimonial grid. The closing CTA is now the plate-on-pixel-band composite
   inlined in each Landing*Page (home/products/customers), so it lives there. */

/* backdrop pixel-art scene per product pillar — one site-wide mapping, used by the
   home hero showcase and the products pillars (classes defined in the stylesheet):
   street (Capture) · shops (Engage) · canal (Évalue) · sunset (Analyse) */
export const PILLAR_BG_CLASSES = ['sig', 'crb', 'dwn', 'atm'];

/* Section header — title (+ optional sub). Eyebrow/kicker removed by design. */
export function SectionHeading({
  title, sub, center, maxw, submaxw,
}: {
  title: string; sub?: string;
  center?: boolean; maxw?: string; submaxw?: string;
}) {
  return (
    <div className={center ? 'b-center' : ''}>
      <h2 className="b-h2 b-mt0" style={{ maxWidth: maxw, marginInline: center ? 'auto' : undefined }}>
        <Highlight text={title} />
      </h2>
      {sub && (
        <p className="b-lede" style={{ marginTop: 18, marginInline: center ? 'auto' : undefined, maxWidth: submaxw || (center ? '60ch' : '64ch') }}>
          {sub}
        </p>
      )}
    </div>
  );
}

export function TestimonialGrid({ items }: { items: CultivTestimonial[] }) {
  const hero = items.find((q) => q.featured);
  const rest = items.filter((q) => !q.featured);
  return (
    <>
      {hero && (
        <figure className="b-quote-hero">
          <p><Highlight text={hero.text} /></p>
          <figcaption className="by">
            <div className="av">{hero.avatar}</div>
            <div><div className="nm">{hero.name}</div><div className="rl">{hero.role}</div></div>
          </figcaption>
        </figure>
      )}
      <div className="b-tgrid">
        {rest.map((q, i) => (
          <div className="b-quote" key={i}>
            <p>{q.text}</p>
            <div className="by">
              <div className="av">{q.avatar}</div>
              <div><div className="nm">{q.name}</div><div className="rl">{q.role}</div></div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
